module.exports = __webpack_public_path__ + "img/messages.990270ae.svg";